import { render } from "./AddLoadshedding.vue?vue&type=template&id=989c4a58"
import script from "./AddLoadshedding.vue?vue&type=script&lang=js"
export * from "./AddLoadshedding.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__